var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 26,
    height: 26,
    rx: 4.5,
    fill: "#1D4469"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 26,
    height: 26,
    rx: 4.5,
    stroke: "#F0F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 13.8125H14.1875V9.6875C14.1875 9.30781 13.8797 9 13.5 9C13.1203 9 12.8125 9.30781 12.8125 9.6875V13.8125H8.6875C8.30781 13.8125 8 14.1203 8 14.5C8 14.8797 8.30781 15.1875 8.6875 15.1875H12.8125V19.3125C12.8125 19.6922 13.1203 20 13.5 20C13.8797 20 14.1875 19.6922 14.1875 19.3125V15.1875H18.3125C18.6922 15.1875 19 14.8797 19 14.5C19 14.1203 18.6922 13.8125 18.3125 13.8125Z",
    fill: "#F0F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.f790e9a2df6a72a15c9ca9fe60133098.svg";
export { ForwardRef as ReactComponent };